import { IMembership } from '../../interfaces/IMyMembership';

interface IMemberLabelMyAccount {
  membershipInfo: IMembership;
  subscriptionState?: string | null;
}

interface IMemberLabelGlobalNav {
  membershipInfo: IMembership;
  role: string;
  planCode: string;
}

const planCodes = {
  annual: 'fffvipa',
  seasonal: 'fffvip',
};

const planCodesLabel = {
  [planCodes.annual]: 'Annual',
  [planCodes.seasonal]: 'Seasonal',
};

const MEMBER_LABEL = 'Member';
const SELECT_LABEL = ' / Select Member';
const SELECT_LABEL_SEASONAL = ' / Select Access';

export const getMembershipLabelMyAccount = ({
  membershipInfo,
  subscriptionState,
}: IMemberLabelMyAccount) => {
  if (!subscriptionState || !membershipInfo?.flags || membershipInfo?.flags.length === 0) {
    return '';
  }

  if (membershipInfo?.isRefillSubscription) {
    return MEMBER_LABEL;
  }

  // Annual is the gold tier holding a core box — derived from the membership endpoint (tier +
  // flags) rather than the legacy `/accounts` planCode field (FP-1322). The box can be active
  // (`has_box_subscription` / `has_annual_box_subscription`) or lapsed
  // (`expired_box_subscription` / `canceled_box_subscription`); legacy labeled annual regardless of
  // state, so the classification must be state-agnostic to keep expired/canceled annuals labeled.
  const coreBoxFlags = [
    'has_box_subscription',
    'has_annual_box_subscription',
    'has_seasonal_box_subscription',
    'expired_box_subscription',
    'canceled_box_subscription',
  ];
  const isAnnual =
    membershipInfo?.tier?.display_name === 'gold' &&
    membershipInfo.flags.some((flag) => coreBoxFlags.includes(flag.display_name));

  if (isAnnual) {
    return 'Annual Member';
  }

  return MEMBER_LABEL;
};

export const getMembershipLabelGlobalNav = ({
  membershipInfo,
  role,
  planCode,
}: IMemberLabelGlobalNav) => {
  if (
    !membershipInfo?.membership_state ||
    !membershipInfo?.flags ||
    membershipInfo?.flags.length === 0
  ) {
    return '';
  }

  if (membershipInfo?.isRefillSubscription) {
    return MEMBER_LABEL;
  }

  if (planCode === planCodes.annual || planCode === planCodes.seasonal) {
    const isAnnual = planCode === planCodes.annual;
    const selectText = isAnnual ? SELECT_LABEL : SELECT_LABEL_SEASONAL;
    return `${planCodesLabel[planCode]}${role === 'SELECT' || isAnnual ? selectText : ''}`;
  }

  return MEMBER_LABEL;
};
